import { Component, Input, OnInit } from '@angular/core';
import { RentalsService } from '../../../../../../../services/rentals.service';
import { HelpersService } from '../../../../../../../services/helpers.service';
import { NotificationService } from '../../../../../../../services/notification.service';

@Component({
  selector: 'app-rental-reservation-messaging',
  templateUrl: './rental-reservation-messaging.component.html',
  styleUrls: ['./rental-reservation-messaging.component.scss'],
})
export class RentalReservationMessagingComponent implements OnInit {
  @Input() reservation;
  @Input() messageService;

  public header: string;
  public text: string;
  public sendingState: string;
  public notifications: any = [];
  public loading = false;
  public sending = false;
  public countryData: any = {};
  public partnerData: any = {};
  public isWhatsappCustomMessageWindowOpen: boolean = false;
  public whatsappFeatureEnabled: boolean = false;
  public hasInitiateChatTemplate: boolean = false;
  public busyInitiatingChat: boolean = false;
  public defaultMessageType: string = 'SMS';

  constructor(
    private helpersService: HelpersService,
    private rentalsService: RentalsService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    this.partnerData = this.helpersService.getPartnerData();
    this.getReservationMessages();
    this.checkIfWhatsappCustomMessageWindowOpen();
  }

  getReservationMessages() {
    this.loading = true;
    this.rentalsService
      .getRentalReservationMessages(this.partnerData.ID, this.reservation.id)
      .subscribe(
        (notifications) => {
          this.notifications = notifications.reverse();
          this.cleanDate();
          this.loading = false;
          setTimeout(() => {
            this.updateScroll();
          }, 100);
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  checkIfWhatsappCustomMessageWindowOpen() {
    this.notificationService.checkIfWhatsappCustomMessageWindowOpen(this.partnerData.ID, "RESERVATION", this.reservation.id).subscribe(res => {
      this.whatsappFeatureEnabled = res.useWhatsappFeatures;
      this.isWhatsappCustomMessageWindowOpen = res.isMessageWindowOpen;
      this.hasInitiateChatTemplate = res.hasInitiateChatTemplate;
      if (this.whatsappFeatureEnabled && (this.hasInitiateChatTemplate || this.isWhatsappCustomMessageWindowOpen)) {
        this.defaultMessageType = "WHATSAPP";
      }
    })
  }

  sendInitiateWhatsappChatTemplate() {
    this.busyInitiatingChat = true;
    this.notificationService.sendInitiateWhatsappChatTemplate(this.partnerData.ID, "RESERVATION", this.reservation.id).subscribe(res => {
      this.getReservationMessages();
      this.busyInitiatingChat = false;
      //Check again in 5 seconds, allow time for delivery and webhooks to finish
      setTimeout(() => {
        this.getReservationMessages();
        this.sending = false;
      }, 5000);
    }, err => {
      this.busyInitiatingChat = false;
    })
  }

  cleanDate() {
    this.notifications.forEach((notification) => {
      console.log(notification);
      notification.CreatedDate = notification.CreatedDate + 'Z';
    });
  }

  updateScroll() {
    var element = document.getElementById('notification-container');
    element.scrollTop = element.scrollHeight;
  }

  sendMessage() {
    var data = {
      ReservationID: this.reservation.id,
      PartnerID: this.partnerData.ID,
      Message: this.text,
      ForceSMS: this.defaultMessageType == "SMS" ? true : false
    };
    this.sending = true;
    this.rentalsService.postRentalReservationMessage(data).subscribe(
      (result) => {
        this.getReservationMessages();
        this.text = '';
        this.sending = false;
        //Check again in 5 seconds, allow time for delivery and webhooks to finish
        setTimeout(() => {
          this.getReservationMessages();
          this.sending = false;
        }, 5000);
      },
      (err) => {
        this.sending = false;
      },
    );
  }
}
